<template>
    <button :type="type ? type : 'button'" :disabled="submitting || disabled ? 'disabled' : null" class="md-button md-raised md-primary md-theme-default" v-on:click="onClick($event)">
        <div class="md-ripple md-disabled">
            <div class="md-button-content">
                {{ label }}
            </div>
        </div>
        <md-progress-bar v-show="submitting" md-mode="indeterminate"></md-progress-bar>
    </button>
</template>

<script>
    export default {
        props: {
            submitting: Boolean,
            label: String,
            type: String,
            disabled: Boolean,
        },
        methods: {
            onClick(event) {
                event.preventDefault();
                this.$emit('click');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/SubmitButtonComponent.vue